import React from 'react';
import { universityMarks } from '../../data/discoverVisual';
import { cn } from '../../utils/cn';
import type { UniversityProfile } from '../../types/admissions';

/**
 * The identifying mark on a university card.
 *
 * Campuzon does not hold licensed institutional crests, and inventing one would
 * imply an official relationship that does not exist. This renders a stable,
 * recognisable initial mark instead — clearly a Campuzon treatment.
 */
const SIZES = {
  sm: 'h-9 w-9 text-caption',
  md: 'h-11 w-11 text-body-sm',
  lg: 'h-14 w-14 text-body'
} as const;
interface UniversityMarkProps {
  university: UniversityProfile;
  size?: keyof typeof SIZES;
  className?: string;
}
export function UniversityMark({
  university,
  size = 'md',
  className
}: UniversityMarkProps) {
  const mark = universityMarks[university.id] ?? {
    initials: university.shortName.slice(0, 2).toUpperCase(),
    className: 'bg-ink-muted text-white'
  };
  return <span aria-hidden className={cn('flex shrink-0 items-center justify-center rounded-xl font-bold tracking-tight ring-2 ring-surface', SIZES[size], mark.className, className)} data-id="element-1678" data-mp="104ow51sh21qi">
      {mark.initials}
    </span>;
}